/**
 * Smart sticky header — hides on scroll down, reappears on scroll up.
 * Targets #header. Guards against hiding while mobile menu is open.
 */
(function () {
    const header = document.getElementById('header');
    if (!header) return;

    let lastScrollY = window.scrollY;
    let ticking = false;
    const threshold = 10;

    function update() {
        const currentScrollY = window.scrollY;
        const delta = currentScrollY - lastScrollY;

        // Don't hide if mobile menu is open
        const mobileMenu = document.getElementById('mobileMenu');
        const menuOpen = mobileMenu && mobileMenu.classList.contains('is-active');

        if (Math.abs(delta) < threshold) {
            ticking = false;
            return;
        }

        if (currentScrollY <= 0) {
            // At top
            header.classList.remove('header--hidden', 'header--shadow');
            header.classList.add('header--top');
        } else if (delta > 0 && !menuOpen) {
            // Scrolling down
            header.classList.add('header--hidden');
            header.classList.remove('header--shadow', 'header--top');
        } else {
            // Scrolling up
            header.classList.remove('header--hidden', 'header--top');
            header.classList.add('header--shadow');
        }

        lastScrollY = currentScrollY;
        ticking = false;
    }

    window.addEventListener(
        'scroll',
        function () {
            if (!ticking) {
                requestAnimationFrame(update);
                ticking = true;
            }
        },
        { passive: true }
    );
})();
